/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

export const responseParser = async (response: AxiosResponse<any>) => {
  const { data, status, statusText } = response;
  return { data, status, statusText } as any;
};
